module.exports = __webpack_public_path__ + "static/kranDaten02-b0d5629dc03c199eca387074e7b65e0a.jpg";